module.exports = __webpack_public_path__ + "media/images/lb/854-d183774980328e0442d1ba4f61b1422e.svg";